"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeView = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var icons_1 = require("../icons");
var tree_item_1 = require("../tree-item");
var tree_view_context_1 = require("./tree-view-context");
function hasSomeNodesWithChildren(children) {
    var childrenNodes = Array.isArray(children) ? children : [children];
    return childrenNodes.some(function (child) {
        if (!react_1.default.isValidElement(child)) {
            return false;
        }
        if (child.type && child.type === tree_item_1.TreeItemChildren) {
            return true;
        }
        if (child.props && child.props.children) {
            return hasSomeNodesWithChildren(child.props.children);
        }
        return false;
    });
}
function TreeView(_a) {
    var _b = _a.expandedIcon, expandedIcon = _b === void 0 ? react_1.default.createElement(icons_1.TreeViewExpandedIcon, null) : _b, _c = _a.collapsedIcon, collapsedIcon = _c === void 0 ? react_1.default.createElement(icons_1.TreeViewCollapsedIcon, null) : _c, _d = _a.itemsGap, itemsGap = _d === void 0 ? 8 : _d, children = _a.children, _e = _a.expanded, expanded = _e === void 0 ? false : _e, _f = _a.toggleButtonOptions, toggleButtonOptions = _f === void 0 ? { width: 26, height: 21 } : _f;
    return (react_1.default.createElement(StyledTreeView, { role: "tree" },
        react_1.default.createElement(tree_view_context_1.TreeViewProvider, { expandedIcon: expandedIcon, collapsedIcon: collapsedIcon, itemsGap: itemsGap, expanded: expanded, toggleButtonOptions: toggleButtonOptions, areAllNodesLeaf: !hasSomeNodesWithChildren(children) }, children)));
}
exports.TreeView = TreeView;
var StyledTreeView = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  padding: 0;\n  list-style: none;\n"], ["\n  padding: 0;\n  list-style: none;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map